import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Auth from '../../../../auth/auth';
import { defaultTheme, PageShell, TopBar, UserChip, NxButton, NxIcon } from '../../../../components/nx';
import makeRequest from '../../../../api/makeRequest';
import url from '../../../../api/urls';
import { RequstMethods } from '../../../../api/requestMethode';
import { renderMarkdown } from '../../../../helpers/markdownHelper';
import { ExamService } from '../../../../Services/examServices';
import { AuthService } from '../../../../Services/authServices';
import toast from 'react-hot-toast';
import fingerPrint from '../../../../helpers/fingerprintjs';

const t = defaultTheme;

const FRSCInstructions = () => {
    const navigate = useNavigate();
    const [title, setTitle] = useState<string>("");
    const [content, setContent] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [profile, setProfile] = useState<any>();

      async function getProfile() {
            try {
                const res = await ExamService.getUserInfoWtihoutExams();
                if (res.status === 200) {
                    setProfile(res.data.data.studentInfo[0]);
                }
            } catch (e) { }
        }


    useEffect(() => {
        async function fetchInstructions() {
            try {
                const res = await makeRequest(url.settings.getByKey + "/instructions", RequstMethods.GET);
                if (res.status === 200 && res.data.data) {
                    setTitle(res.data.data.instructionTitle || "");
                    setContent(res.data.data.instructionContent || "");
                }
            } catch (e) {
                console.error("Failed to fetch instructions", e);
            } finally {
                setLoading(false);
            }
        }
        fetchInstructions();
        getProfile();
    }, []);

    async function handleLogout() {
        try {
            const res = await AuthService.logout({ devInfo: await fingerPrint() });
            if (res.status === 200) {
                Auth.signout();
                localStorage.setItem("authKey", res.data.data.token);
                toast.success("Logged out");
            }
            navigate('/login');
        } catch (err) {
            navigate('/login');
        }
    }
    const profileName = profile ? `${profile.name || ''} ${profile.last_name || ''}`.trim() : 'User';

    return (
        <PageShell t={t} style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <TopBar t={t} crumbs={['Instructions']} right={<UserChip t={t} name={profileName} email={profile?.email} regNo={profile?.registrationNumber} onLogout={handleLogout} onProfile={() => navigate('/exam/user/profile')} />} />

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{
                    width: '100%', maxWidth: 900,
                    background: t.surface, border: `1px solid ${t.border}`, borderRadius: 14,
                    overflow: 'hidden',
                }}>
                    <div style={{
                        padding: '20px 28px', borderBottom: `1px solid ${t.border}`,
                        background: t.paperAlt,
                    }}>
                        <h2 style={{ fontSize: 16, fontWeight: 600, color: t.ink, margin: 0 }}>
                            {loading ? "Loading..." : title || "Instructions"}
                        </h2>
                    </div>

                    <div style={{ padding: 28, fontSize: 14, lineHeight: 1.7, color: t.ink }}>
                        {loading ? (
                            <p style={{ color: t.inkMute }}>Loading instructions...</p>
                        ) : content ? (
                            <div dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }} />
                        ) : (
                            <p style={{ color: t.inkMute }}>No instructions available.</p>
                        )}

                        <div style={{ marginTop: 28 }}>
                            <NxButton t={t} kind="primary" icon={NxIcon.arrowRight('#fff')} onClick={() => navigate("/exam/dashboard")}>
                                Continue
                            </NxButton>
                        </div>
                    </div>
                </div>
            </div>
        </PageShell>
    );
};

export default FRSCInstructions;
